export default __webpack_public_path__ + "static/media/file-case.e601b8f8.svg";